// @ts-nocheck
/* eslint-disable */
import { CONFIG } from "~/config";

(function() {
	const URL = "/licence/v1";

	function addLang(data) {
		return Object.assign({ lang: CONFIG.defaultLang }, data);
	}

	Mapy.ProviderLicence = {};

	Mapy.ProviderLicence.check = function(data = {}) {
		const url = new URLSearchParams(addLang(data));

		return Mapy.Util.request(CONFIG.requestUrl + URL + '/check/mapy?' + url.toString());
	};

	Mapy.ProviderLicence.approve = function(data) {
		return Mapy.Util.request(CONFIG.requestUrl + URL + '/approve/mapy', { json: data });
	};

	Mapy.ProviderLicence.documents = function(data = {}) {
		const url = new URLSearchParams(addLang(data));

		return Mapy.Util.request(CONFIG.requestUrl + URL + '/documents?' + url.toString());
	};
})();
